import React from "react";
import { Check } from "lucide-react";

const Checkbox = ({ checked, onChange, label, className = "" }) => {
  return (
    <label className={`relative inline-flex items-center gap-2 cursor-pointer ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="sr-only peer"
      />
      <div className="w-4 h-4 rounded border-[1.5px] border-[#333E48] peer-checked:text-blue-shade-2 peer-checked:border-blue-shade-2 flex items-center justify-center transition-colors">
        {checked && <Check size={11} strokeWidth={3} />}
      </div>
      {label && <span className="text-sm text-[#FEFCEB]">{label}</span>}
    </label>
  );
};

export default Checkbox;
